<template>
  <div class="page-container">
    <div class="page-card">
      <!-- 表单头部 -->
      <div class="page-card__header">
        意见反馈
      </div>

      <!-- 表单内容 -->
      <div class="page-card__body">
        <el-form :model="opinionForm" ref="opinionForm" :rules="rules" style="width: 600px; margin: 0 auto">
          <el-form-item prop="content" label="反馈内容：">
            <el-input type="textarea" :rows="6" placeholder="请输入内容" v-model="opinionForm.content"></el-input>
          </el-form-item>
          <div style="margin: 20px 0 10px 0"><i class="el-icon-phone"></i> 联系方式：</div>
          <el-form-item prop="contact">
            <el-input v-model="opinionForm.contact" placeholder="输入联系方式"></el-input>
          </el-form-item>
          <div style="text-align: center; margin: 40px 0">
            <el-button size="small" type="primary" @click="sumbitOn('opinionForm')">提交反馈</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '../../utils/api'

  export default {
    name: "opinion",
    data() {
      return {
        opinionForm: {
          content: '',
          contact: '',
        },
        rules: {
          content: [{required: true, message: '请输入反馈内容', trigger: 'blur'},],
          contact: [{required: true, message: '请输入联系方式', trigger: 'blur'},],
        },
      }
    },

    methods: {
      // 提交意见反馈
      sumbitOn(formname) {
        this.$refs[formname].validate((valid) => {
          if (valid) {
            let id = localStorage.getItem('userid');
            let url = this.baseUrl + '/user/messages/';
            api.postData(url, {
              content: this.opinionForm.content,
              contact: this.opinionForm.contact,
              type: 2,
              userid: id
            }).then((res) => {
              this.$message({
                message: '添加产品成功',
                type: 'success'
              })
              this.opinionForm.content = '';
              this.opinionForm.contact = '';
            })
          }
        })
      },
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/manage/opinion.vue